// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"517":"calendar","962":"home"}[chunkId] + "." + {"517":"a1a5fbd9","962":"1580d95a"}[chunkId] + ".css";
};